import {CommonService} from 'src/app/services/common.service';
import {Component, Input, OnChanges, ViewChild} from '@angular/core';
import {LoadingService} from 'src/app/services/loading.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {SuperMarketRefrigeratorBudgetService} from 'src/app/services/super-market-refrigerator-budget.service';

@Component({
  selector: 'app-redistribution-second-step',
  styleUrls: ['./redistribution-second-step.component.scss'],
  templateUrl: './redistribution-second-step.component.html'
})

export class RedistributionSecondStepComponent implements OnChanges {
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  public loadingOrderDetailsColumns: string[];
  @Input() data: any;
  public dataSource: MatTableDataSource<any>;
  public title: string;

  constructor(private commonService: CommonService,
              private loadingService: LoadingService,
              private superMarketBudgetService: SuperMarketRefrigeratorBudgetService) {

    this.loadingOrderDetailsColumns = [
      'head_quarter_name',
      'category_name',
      'is_led_name',
      'available_quantity',
      'redistributions',
      'final_quantity'
    ];
  }
  public async ngOnChanges(): Promise<any> {
    if (this.data) {
      this.dataSource = new MatTableDataSource<any>(this.data);
      this.initPaginatorAndSort();

      for (const d of this.dataSource.data) {
        d.final_quantity = d.available_quantity;
      }
      this.title = `${this.dataSource.data[0].material_id}  ${this.dataSource.data[0].material_name}`;

      this.loadingService.hide();
    }
  }

  private initPaginatorAndSort() {
    this.dataSource.paginator = this.commonService.setPaginatorTexts(this.paginator);
    this.dataSource.sort = this.sort;
  }

  public updateData(index: number, event: any): void {
    if (index !== -1) {
      this.dataSource.data[index].final_quantity = +event.target.value + this.dataSource.data[index].available_quantity;
    }
  }

  getTotal(field: string) {
    return this.dataSource ? this.dataSource.data.map(t => t[field]).reduce((acc, value) => acc + (+value || 0), 0) : '-';
  }

  public isInvalid(): boolean {
    let invalid = false;
    for (const row of this.dataSource.data) {
      if (row.redistributions < -row.available_quantity) {
        invalid = true;
      }
    }

    return this.getTotal('available_quantity') !== this.getTotal('final_quantity') || invalid;
  }

  async submit() {
    return await this.superMarketBudgetService.updateRedistribution(this.dataSource.data);
  }
}
